<mat-icon [fontSet]="fontSet" class="outlined-icon" [ngStyle]="{color: color}">
  {{ icon }}
</mat-icon>
